module.exports = __webpack_public_path__ + "static/media/post-it-bg.e1b26081.svg";